import React, { Component } from "react";
import Button from "@mui/material/Button";
import Quiz from "../components/Quiz";
import { withRouter } from "react-router-dom";
import Slider from "@mui/material/Slider";
import Tutorial from "../components/Tutorial";
import "../styles/home.css";

class Test extends Component {
  constructor(props) {
    super(props);
    this.state = { viewTest: false };
    this.volume = 50;
  }

  changeVolume(value) {
    if (value !== this.volume) {
      this.volume = value;
    }
  }

  render() {
    return (
      <>
        {this.state.viewTest ? (
          <Quiz
            side={this.props.location.state.side}
            mode={this.props.location.state.mode}
            volume={this.volume}
          ></Quiz>
        ) : (
          <>
            <div id="centered-container-quiz" className="centered-container">
              <Tutorial />
              <Button
                variant="outlined"
                className="outlined-button outlined-button-blue"
                onClick={() => {
                  hide("centered-container-quiz");
                  this.setState({ viewTest: true });
                }}
              >
                Áno
              </Button>
              <Button
                variant="outlined"
                className="outlined-button outlined-button-red"
                onClick={() => {
                  this.props.history.push("/");
                }}
              >
                Nie
              </Button>
              <div className="quiz-text">Hlasitosť</div>
              <Slider
                className="volume-slider"
                aria-label="Volume"
                defaultValue={50}
                valueLabelDisplay="auto"
                step={1}
                onChangeCommitted={(_, v) => this.changeVolume(v)}
              />
            </div>
          </>
        )}
      </>
    );
  }
}

function hide(id) {
  document.getElementById(id).style.display = "none";
}

export default withRouter(Test);
